import { TrainRouteDiscrepancies } from "features/VehicleSidebar/AffectedTrains/types";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, ExpandableAlert, Text } from "shared/components/Spor";

export const TrainRouteDiscrepancyWarning: FC<{
  trainRouteDiscrepancies: TrainRouteDiscrepancies;
  title?: string;
}> = ({ trainRouteDiscrepancies, title }) => {
  const { t } = useTranslation();

  if (trainRouteDiscrepancies === null) return null;

  return (
    <ExpandableAlert
      data-color="warning"
      width="100%"
      borderRadius="12px"
      css={{ "& h3": { WebkitLineClamp: "none" } }}
      title={title ?? t("Sjekk at du velger riktige tog")}
    >
      <Text>
        {t(
          "Noen tog i samme serie kjører i ulike traséer. Sjekk at du velger riktige tog til behandling:",
        )}
      </Text>
      <Box pl={4}>
        <ul>
          {Object.entries(trainRouteDiscrepancies).map(([series, group]) => (
            <li key={series}>
              <Text gridColumn="2" maxWidth="100%">
                {series}:{" "}
                {group
                  .map((route) => route.split("___").join(`\u2013`).trim())
                  .join(", ")}
              </Text>
            </li>
          ))}
        </ul>
      </Box>
    </ExpandableAlert>
  );
};
